export { AlarmDefinitionsBulkEditComponent, COMPONENT_NAME} from './alarm-definitions-bulk-edit.component'
export { AlarmDefinitionsBulkEditController } from './alarm-definitions-bulk-edit.controller'
